// import React, { useState } from "react";
// import '/SOFTWARE/reactApp/Sayali-React/exam-app/src/Components/Login-Components/Login.css';
// import logo from '/SOFTWARE/reactApp/Sayali-React/exam-app/src/Assets/graduation-cap.jpg';
// import { FiLock, FiEye, FiEyeOff, FiUser } from 'react-icons/fi';
// import { useNavigate, Link } from "react-router-dom";
// import './AdminLogin.css';
// import studentImage from '../../Assets/student1.png'
// function AdminLogin() {
//     const navigate = useNavigate();

//     const [adminId, setAdminId] = useState('');
//     const [password, setPassword] = useState('');
//     const [showPassword, setShowPassword] = useState(false);
//     const [error, setError] = useState('');

//     const handleLogin = (e) => {
//         e.preventDefault();
//         if (adminId.trim() === '') {
//             setError("Admin ID is required.");
//             return;
//         }

//         if (password.trim() === '') {
//             setError("Password is required.");
//             return;
//         }

//         setError('');
//         navigate('/admin-dashboard'); //  Route to admin dashboard
//     };

//     return (
//         <div className="login-container">
//             <div className="login-box">
//                 <img
//                     src={studentImage}
//                     alt="Admin Illustration"
//                     className="student-image avatar-floating"
//                 />

//                 <h1 className="hello-text">Hello!</h1>
//                 <h2 className="welcome-heading">👋 Welcome Admin</h2>

//                 <form onSubmit={handleLogin}>
//                     <div className="input-group">
//                         <FiUser className="icon" />
//                         <input
//                             type="text"
//                             placeholder="Admin"
//                             required
//                             value={adminId}
//                             onChange={(e) => setAdminId(e.target.value)}
//                         />
//                     </div>

//                     <div className="input-group">
//                         <FiLock className="icon" />
//                         <input
//                             type={showPassword ? 'text' : 'password'}
//                             placeholder="Password"
//                             value={password}
//                             onChange={(e) => setPassword(e.target.value)}
//                             required
//                         />
//                         <div
//                             className="toggle-icon"
//                             onClick={() => setShowPassword(!showPassword)}
//                         >
//                             {showPassword ? <FiEyeOff /> : <FiEye />}
//                         </div>
//                     </div>


//                     {error && <p className="error-text">{error}</p>}

//                     <button type="submit" >Login</button>

//                     <div className="student-login-link"> {/* ADDED */}
//                         <p>
//                             <Link to="/">Back to Student Login</Link>
//                         </p>
//                     </div>


//                 </form>

//                 {/* <footer className="login-footer">
//                     <p>© 2025 YourCompany. Powered by YourTech</p>
//                 </footer> */}
//             </div>
//         </div>
//     );
// }

// export default AdminLogin;



import React, { useState, useRef } from 'react';
import { motion } from 'framer-motion';
import { Player } from '@lottiefiles/react-lottie-player';
import { FiUser, FiLock, FiEye, FiEyeOff } from 'react-icons/fi';
import { Link, useNavigate } from 'react-router-dom';
import { Toast } from 'primereact/toast';
import '../Login-Components/StudentLogin.css';
import './AdminLogin.css';
import api from '../../api';
import studentImage from '../../Assets/Admin.png';

function AdminLogin() {
    const navigate = useNavigate();
    const toast = useRef(null);
    const [adminId, setAdminId] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const handleLogin = async (e) => {
        e.preventDefault();

        if (!adminId.trim() || !password.trim()) {
            toast.current.show({
                severity: 'warn',
                summary: 'Warning',
                detail: 'Please fill in all fields',
            });
            return;
        }

        setLoading(true);

        try {
            // ✅ Use api instance instead of axios
            const response = await api.post('/admin-login', {
                adminId,
                password
            });

            const { user, token } = response.data;

            // ✅ Save token so interceptor can use it
            // AdminLogin.js
            localStorage.setItem('auth_token', token); // changed from 'adminToken'
            localStorage.setItem('auth_user', JSON.stringify(user)); // changed from 'adminData'

            toast.current.show({
                severity: 'success',
                summary: 'Success',
                detail: 'Logged in successfully!',
            });

            navigate('/admin-dashboard');

        } catch (error) {
            if (error.response) {
                toast.current.show({
                    severity: 'error',
                    summary: 'Login Failed',
                    detail: error.response.data.message || 'Invalid credentials',
                });
            } else {
                toast.current.show({
                    severity: 'error',
                    summary: 'Login Failed',
                    detail: 'Server not reachable',
                });
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login-container">
            <Toast ref={toast} />

            {/* Left Panel: Animation */}
            <motion.div
                className="login-left"
                initial={{ x: -100, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                transition={{ duration: 1 }}
                style={{ flex: 0.9 }}
            >
                <Player
                    autoplay
                    loop
                    src="https://assets10.lottiefiles.com/packages/lf20_jcikwtux.json"
                    style={{ height: '100%', width: '100%', maxWidth: '400px' }}
                />
            </motion.div>

            {/* Right Panel: Login Form */}
            <motion.div
                className="login-right"
                initial={{ x: 100, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                transition={{ duration: 1 }}
                style={{ flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center' }}
            >
                <div className="login-box">
                    <div className="login-header">
                        <img
                            src={studentImage}
                            alt="Admin Illustration"
                            className="student-image avatar-floating"
                        />
                        <h1 className="hello-text">Hello!</h1>
                        <h2 className="welcome-heading">
                            <span className="wave-emoji">👋</span> Welcome Admin
                        </h2>
                    </div>

                    <form onSubmit={handleLogin}>
                        {/* Admin ID Input */}
                        <motion.div className="input-group">
                            <FiUser className="icon" />
                            <input
                                type="text"
                                placeholder="Admin ID"
                                required
                                value={adminId}
                                onChange={(e) => setAdminId(e.target.value)}
                            />
                        </motion.div>

                        {/* Password Input */}
                        <motion.div className="input-group">
                            <FiLock className="icon" />
                            <input
                                type={showPassword ? 'text' : 'password'}
                                placeholder="Password"
                                required
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                            />
                            <div
                                className="toggle-icon"
                                onClick={() => setShowPassword(!showPassword)}
                            >
                                {showPassword ? <FiEyeOff /> : <FiEye />}
                            </div>
                        </motion.div>

                        {error && <p className="error-text">{error}</p>}

                        {loading && (
                            <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '10px' }}>
                                <Player
                                    autoplay
                                    loop
                                    src="https://assets9.lottiefiles.com/packages/lf20_usmfx6bp.json"
                                    style={{ height: '60px', width: '60px' }}
                                />
                            </div>
                        )}

                        <button type="submit" disabled={loading}>
                            {loading ? 'Logging in...' : 'Login'}
                        </button>

                        <div className="back-to-student">
                            <p><Link to="/">Back to Student Login</Link></p>
                        </div>
                    </form>
                </div>
            </motion.div>
        </div>
    );
}

export default AdminLogin;










